import { Injectable } from '@angular/core';
import { PublisherModel } from '@app/pages/publisher/models/publisher-model';
import { ProfileVisibilityEnum } from '@shared/model/account-setting-model';
import { ActivitiesAggrigatorModel } from '@shared/model/activities-aggrigator-model';
import { CustomerModel } from '@shared/model/customerModels/customer-model';
import { ActivityVerbEnum } from '@shared/model/enum/activity-verb-enum';
import { ObjectTypeEnum } from '@shared/model/enum/object-type-enum';
import { FollowsModel } from '@shared/model/followModels/follow-model';


@Injectable({
    providedIn: 'root'
})
export class ProfileUtilitiesService {

    public AdaptPublisherToCustomerModel(publisher: PublisherModel): CustomerModel {
        return {
            myFollowState: publisher.myFollowState,
            lastSyncContactDate: '',
            isLastSyncContactDate: true,
            followersCount: 0,
            hasFollowRequest: false,
            firstName: publisher.title,
            lastName: '',
            fullName: '',
            uniqeName: publisher?.userName,
            phoneNumber: publisher?.phoneNumber,
            email: publisher?.email,
            id: publisher?.id,
            city: publisher?.city,
            address: publisher?.address,
            createdAt: publisher?.createdAt,
            visibility: ProfileVisibilityEnum.Everybody,
            roleNames: 'Publisher',
            hasPhoto: publisher?.hasPhoto,
            hasWallpaper: publisher?.hasWallpaper,
            website: publisher?.website,
            activityScope: publisher?.activityScope,
            bio: publisher?.description,
            userIsPublisher: true
        } as CustomerModel;
    }


    public mapUserToFollowsModel(user: CustomerModel): FollowsModel {
        return {
            myFollowStateWith: user?.myFollowState || null,
            hasPhoto: user?.hasPhoto,
            objectId: user?.id,
            objectTypeId: '',
            fullName: user?.firstName,
            userName: user?.uniqeName
        } as FollowsModel;
    }

    public checkValidActivity(activity: ActivitiesAggrigatorModel): boolean {
        return (activity.verb != ActivityVerbEnum.Followed) &&
            (activity.verb != ActivityVerbEnum.Chanllenged) &&
            (activity.verb != ActivityVerbEnum.Joined) &&
            (activity.inDirectObject?.data) &&
            (activity.inDirectObject?.objectType != ObjectTypeEnum.Challenge);
    }
}
